import { MinusIcon, PlusIcon } from '@src/assets';
import { FunctionComponent } from 'react';
import { useFormContext } from 'react-hook-form';
import { FlexRow } from './styled/FlexRow.styled';
import * as styled from './styled/Incrementer.styled';
import { Label } from './styled/Label.styled';
import { NumberInput } from './styled/NumberInput.styled';

export const Incrementer: FunctionComponent<{
    disabled?: boolean;
    label: string;
    name: string;
    incrementStep?: number;
    labelRight?: boolean;
    readOnly?: boolean;
    min?: number;
    max?: number;
    roundToDecimal?: boolean;
}> = ({
    disabled = false,
    label,
    name,
    labelRight = false,
    readOnly = true,
    incrementStep = 1,
    min = 0,
    max = 99,
    roundToDecimal = false,
}) => {
    const { register, getValues, setValue } = useFormContext();
    const methods = register(name, {
        min,
        max,
    });

    const getValue = () => parseFloat(getValues(name));
    const increment = () => {
        const value = getValue() + incrementStep;
        if (value <= max) setValue(name, roundToDecimal ? Math.round(value * 10) / 10 : value);
    };
    const decrement = () => {
        const value = getValue() - incrementStep;
        if (value >= min) setValue(name, roundToDecimal ? Math.round(value * 10) / 10 : value);
    };

    return (
        <FlexRow gap={11} flexDirection={labelRight ? 'row-reverse' : 'row'}>
            <Label>{label}</Label>
            <styled.Incrementer disabled={disabled}>
                <button disabled={disabled} onClick={decrement} type="button">
                    <MinusIcon />
                </button>
                <NumberInput
                    disabled={disabled}
                    readOnly={readOnly}
                    type="number"
                    {...methods}
                    onBlur={(e) => {
                        const value = parseFloat(e.target.value);
                        // Prevent value > max
                        if (value > max) setValue(name, max);

                        // Prevent value < min
                        if (value < min) setValue(name, min);

                        // Prevent value have more than 1 decimal place
                        if (value > min && value < max)
                            setValue(name, roundToDecimal ? Math.round(value * 10) / 10 : value);
                    }}
                    onKeyDown={(e) => {
                        if (['e', '+', '-'].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
                <button disabled={disabled} onClick={increment} type="button">
                    <PlusIcon />
                </button>
            </styled.Incrementer>
        </FlexRow>
    );
};
